import React from "react";
import { Box, Button } from "@mui/material";
import { State, StateProps } from "./state";
import { getAuth, logout } from "../api/getAuth";
import { localStorageEmailKey } from "../App";
import { SxProps, Theme } from "@mui/material/styles";

export async function logoutState(props: StateProps) {
  await logout();
  localStorage.removeItem("authToken");
  localStorage.removeItem("email");
  props.setState((prevState: State) => {
    return {
      ...prevState,
      loggingIn: false,
      user: undefined,
    };
  });
  window.location.reload();
}

function generateState() {
  const validChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  return Array.from({ length: 40 })
    .map((i) => validChars[Math.floor(Math.random() * validChars.length)])
    .join("");
}

export interface OpenPopupProps {
  readonly setRefreshing: React.Dispatch<React.SetStateAction<boolean>>;
}
async function openPopup(props: OpenPopupProps) {
  const { setRefreshing } = props;
  // To fix issues with window.screen in multi-monitor setups, the easier option is to
  // center the pop-up over the parent window.
  const popupHeight = 700;
  const popupWidth = 600;
  const top = window.outerHeight / 2 + window.screenY - popupHeight / 2;
  const left = window.outerWidth / 2 + window.screenX - popupWidth / 2;
  const clientId =
    "515751165720-blq96c6ens08k7sa7qkt0hvq66gms5a3.apps.googleusercontent.com";
  const redirectUri = window.location.origin;
  const scope = "openid email";
  const state = generateState();
  const loginPopUp = window.open(
    `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=${scope}&state=${state}`,
    "OAuth2 Popup",
    `height=${popupHeight},width=${popupWidth},top=${top},left=${left}`,
  );
  var timer = setInterval(async function () {
    if (loginPopUp?.closed) {
      clearInterval(timer);
      if (state === localStorage.getItem("state")) {
        setRefreshing(true);
        const authResponse = await getAuth(localStorage.getItem("signInToken"));
        const authToken = authResponse.token;
        const email = authResponse.email;
        const refreshToken = authResponse.refreshToken;
        localStorage.setItem("authToken", authToken);
        // TODO - use cookie
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem(localStorageEmailKey, email);
        localStorage.removeItem("signInToken");
        localStorage.removeItem("state");
        window.location.reload();
      }
    }
  }, 1000);
}

export interface LoginModalProps extends StateProps {
  readonly setRefreshing: any;
}
export function LoginModal(props: LoginModalProps) {
  const setRefreshing = props.setRefreshing;
  return (
    <Box sx={{ height: "100%" }}>
      {localStorage.getItem("authToken") !== null ? (
        <Button
          color="inherit"
          onClick={() => {
            logoutState({ ...props });
          }}
        >
          Logout
        </Button>
      ) : (
        <Button
          color="inherit"
          onClick={() => {
            openPopup({ setRefreshing });
          }}
        >
          Login
        </Button>
      )}
    </Box>
  );
}

export interface LoginButtonProps extends StateProps {
  readonly setRefreshing: React.Dispatch<React.SetStateAction<boolean>>;
  readonly sx?: SxProps<Theme>;
  readonly startIcon?: React.ReactNode;
}
export function LoginButton(props: LoginButtonProps) {
  const { startIcon, sx, setRefreshing } = props;
  return (
    <Button
      color="inherit"
      sx={sx}
      startIcon={startIcon}
      onClick={
        localStorage.getItem("authToken") !== null
          ? () => {
              logoutState({ ...props });
            }
          : () => {
              openPopup({ setRefreshing });
            }
      }
    >
      {localStorage.getItem("authToken") !== null ? "Logout" : "Login"}
    </Button>
  );
}
